import React from "react";
import Header from "./components/Header";
import Header2 from "./components/Header2"
import HeroSection from "./components/HeroSection";
//  import Features from "./components/Features";
import Servicess from "./components/Servicess";
import Specialities from "./components/Specialities";
import Doctors from "./components/Doctors";
import Testmonials from "./components/Testmonials";
import Whychoseus from "./components/Whychoseus";
import Aboutus from "./components/Aboutus";
import Faqs from "./components/Faqs";
import Appointment from "./components/Appointment";
import Bmicalculator from "./components/Bmicalculator";
//  import MostViewed from "./components/MostViewed";
//  import FindDoctorSection from "./components/FindDoctorSection";
//  import AppDownload from "./components/AppDownload";
import Footer from "./components/Footer";

// Import CSS files
import "./assets/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/css/menu.css";
import "./assets/css/vendors.css";
import "./assets/css/icon_fonts/css/all_icons_min.css";
import "./assets/css/custom.css";

function App() {
  return (
    <>
      <Header />
      <Header2 />
      <HeroSection />
      <Servicess />
      <Doctors />
      <Specialities />
      <Aboutus />
      <Testmonials />
      <Whychoseus />
      <Faqs />
       <Appointment />
        <Bmicalculator />
      {/* <Features />
      <MostViewed />
      <FindDoctorSection />
      <AppDownload /> */}
      <Footer />
    </>
  );
}

export default App;
